import { getNextEvent } from "core-integration/src/store/events/reducers";
import {
  formatRawAsISO,
  formatRawAsLocal,
} from "core-integration/src/utils/datetime";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import { deadline, deadlineBarStyles, eventName } from "./deadlineBar.css";

const DeadlineBar = () => {
  const { deadlineBar } = usePlosTranslations();
  const dateFormat = "E d MMM, HH:mm";
  const nextEvent = useSelector(getNextEvent);
  if (!nextEvent) {
    return null;
  }

  return (
    <div className={deadlineBarStyles}>
      <h3 className={eventName}>{nextEvent.name}</h3>
      <span aria-hidden="true">•</span>
      <h4 className={deadline}>
        {deadlineBar.deadline(
          formatRawAsLocal(nextEvent.deadline_time, dateFormat),
          { dateTime: formatRawAsISO(nextEvent.deadline_time) },
        )}
      </h4>
    </div>
  );
};

export default DeadlineBar;
